"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Colors = require("../00_environment/Colors");

var _Constants = require("../00_environment/Constants");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var RightPaneWidgetFrame = /*#__PURE__*/function (_Component) {
  _inherits(RightPaneWidgetFrame, _Component);

  var _super = _createSuper(RightPaneWidgetFrame);

  function RightPaneWidgetFrame() {
    var _this;

    _classCallCheck(this, RightPaneWidgetFrame);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      leftAnchorPosition: _this.getLeftAnchorPosition()
    };
    return _this;
  }

  _createClass(RightPaneWidgetFrame, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Update left anchor position after first mount
      // As we need #right-pane-widget-frame_container to be in DOM to calculate it
      this.setState({
        leftAnchorPosition: this.getLeftAnchorPosition()
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          _this$props$scrollTop = _this$props.scrollTop,
          scrollTop = _this$props$scrollTop === void 0 ? 0 : _this$props$scrollTop,
          focusedLeftItemId = _this$props.focusedLeftItemId;
      var leftAnchorPosition = this.state.leftAnchorPosition;

      if (prevProps.focusedLeftItemId !== focusedLeftItemId || prevProps.scrollTop !== scrollTop) {
        if (leftAnchorPosition !== this.getLeftAnchorPosition()) {
          this.setState({
            leftAnchorPosition: this.getLeftAnchorPosition()
          });
        }
      }
    }
  }, {
    key: "getLeftAnchorPosition",
    value: function getLeftAnchorPosition() {
      var focusedLeftItemId = this.props.focusedLeftItemId;
      var leftAnchorPosition = null;
      var container = document.getElementById('right-pane-widget-frame_container');
      /*
      console.log('focusedLeftItemId = ', focusedLeftItemId);
      console.log(
        'document.getElementById(focusedLeftItemId) = ',
        document.getElementById(focusedLeftItemId),
      );
      */

      if (focusedLeftItemId && container && document.getElementById(focusedLeftItemId)) {
        var element = document.getElementById(focusedLeftItemId);
        var bounds = element.getBoundingClientRect();
        var containerBounds = container.getBoundingClientRect();

        if (bounds && containerBounds) {
          leftAnchorPosition = (bounds.y || 0) - (containerBounds.y || 0) + Math.round((bounds.height || 0) / 2) - 10;
        }
      }

      return leftAnchorPosition;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          HeaderComponent = _this$props2.headerComponent,
          _this$props2$style = _this$props2.style,
          style = _this$props2$style === void 0 ? {} : _this$props2$style,
          children = _this$props2.children;
      var leftAnchorPosition = this.state.leftAnchorPosition;
      var bgColor = style && style.backgroundColor ? style.backgroundColor : _Colors.paneBackgroundColor;
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "right-pane-widget-frame_container",
        style: _objectSpread({
          position: 'relative',
          width: 'calc(100% - 15px)',
          // Move window 15px right to make sure arrow is shown
          marginLeft: 15,
          // Move window 15px right to make sure arrow is shown
          marginBottom: 100,
          marginTop: 42
        }, style)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'relative',
          backgroundColor: bgColor,
          borderRadius: _Constants.roundedElementBorderRadius,
          // '.3125em',
          border: "1px solid ".concat(_Colors.paneBorderColor),
          // zIndex: 1,
          minHeight: (leftAnchorPosition || 0) + 50
        }
      }, HeaderComponent && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'relative',
          width: '100%',
          zIndex: 30
        }
      }, /*#__PURE__*/_react["default"].createElement(HeaderComponent, null)), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'relative',
          zIndex: 1,
          padding: _Constants.panePadding
        }
      }, children)), leftAnchorPosition && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '20px',
          height: '20px',
          position: 'absolute',
          padding: '1px',
          top: leftAnchorPosition,
          left: '-10px',
          zIndex: 0,
          overflow: 'hidden',
          backgroundColor: bgColor,
          border: "2px solid ".concat(_Colors.paneBorderColor),
          boxShadow: 'none',
          borderBottomColor: '#d5d6db',
          borderRadius: '1px',
          content: "' '",
          display: 'block',
          WebkitTransform: 'rotate(45deg)',
          MozTransform: 'rotate(45deg)',
          MsTransform: 'rotate(45deg)',
          OTransform: 'rotate(45deg)',
          transform: 'rotate(45deg)'
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '20px',
          height: '20px',
          border: "solid 1px ".concat(bgColor),
          position: 'absolute',
          top: leftAnchorPosition,
          left: '-8px',
          zIndex: 2,
          overflow: 'hidden',
          backgroundColor: bgColor,
          display: 'block',
          WebkitTransform: 'rotate(45deg)',
          MozTransform: 'rotate(45deg)',
          MsTransform: 'rotate(45deg)',
          OTransform: 'rotate(45deg)',
          transform: 'rotate(45deg)'
        }
      })));
    }
  }]);

  return RightPaneWidgetFrame;
}(_react.Component);

var _default = RightPaneWidgetFrame;
exports["default"] = _default;